export function lowercaseUsername(email) {
    const [username, domain] = email.split('@');
    const lowercaseUsername = username.toLowerCase();
    return `${lowercaseUsername}@${domain}`;
}
